import Main from './ServiceCategoriesMain'
import Edit from './ServiceCategoriesEdit'
import New from './ServiceCategoriesNew'

const ServiceCategories = { Main, Edit, New }

export default ServiceCategories
